/**
 *
 * 配置
 */

import anchor from './anchor'
import anchorBg from './anchorBg'
import dottedNode from './dottedNode'
import lineAnimate from './lineAnimate'
import shapeControl from './shapeControl'
import line from './line'
import lineArrow from './lineArrow'

export default {
  anchor,
  anchorBg,
  dottedNode,
  lineAnimate,
  shapeControl,
  line,
  lineArrow
}
